module.exports = "/img/whatsapp.png?a36586586850351ec0c2a8ff664c499f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/whatsapp.png
// module id = tMUn
// module chunks = 80